var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.article)?_c('div',[_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.article.content)}})]},{"article":_vm.article})],2):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }